import { AppReducer } from './app-reducer';
import { InitialState } from '../state';

export const MeshDeviceReducer: AppReducer<'MeshDevice'> = (
    state = InitialState.MeshDevice,
    action
): typeof state => {
    switch (action.type) {
        case 'MeshGatewayDevice/Registration/Started':
            return {
                ...state,
                meshgatewayLoading: true,
                meshgatewaySuccess: false,
            };

        case 'MeshGatewayDevice/Registration/Succeeded':
            return {
                ...state,
                meshgatewayLoading: false,
                meshgatewaySuccess: true,
            };

        case 'MeshGatewayDevice/Registration/Failed':
            return {
                ...state,
                meshgatewayLoading: false,
                meshgatewaySuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'MeshGatewayDevice/Registration/Unmounted':
            return {
                ...state,
                meshgatewayLoading: false,
                meshgatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
            };

        default:
            return state;
    }
};
